<template>
  <div class="repair-container">
    <el-card class="box-card">
      <div class="search-area">
        <el-form ref="queryForm" :model="queryParams" label-width="70px" inline size="small">
          <el-form-item label="运营商:" v-if="isAdmin">
            <el-select v-model="queryParams.distributorId" placeholder="请选择" clearable filterable style="width: 150px;">
              <el-option v-for="item in distributorOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="故障类型:">
            <el-select v-model="queryParams.failureType" placeholder="请选择" clearable style="width: 120px;">
              <el-option label="车锁故障" value="lock"></el-option>
              <el-option label="刹车故障" value="break"></el-option>
              <el-option label="车牌故障" value="qr"></el-option>
              <el-option label="支架故障" value="foot"></el-option>
              <el-option label="车头故障" value="head"></el-option>
              <el-option label="链条故障" value="chain"></el-option>
              <el-option label="轮子故障" value="wheel"></el-option>
              <el-option label="其他故障" value="other"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号:">
            <el-input v-model="queryParams.mobile" placeholder="请输入手机号" clearable style="width: 150px;" />
          </el-form-item>
          <el-form-item label="报修时间:">
            <el-date-picker
              v-model="queryParams.dateRange"
              type="daterange"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table-container">
        <el-table :data="repairList" border stripe :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }" v-loading="loading">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
          <el-table-column label="故障类型" min-width="200">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isLockFailure === 1" type="danger" size="small" style="margin: 2px;">车锁故障</el-tag>
              <el-tag v-if="scope.row.isBreakFailure === 1" type="warning" size="small" style="margin: 2px;">刹车故障</el-tag>
              <el-tag v-if="scope.row.isQrFailure === 1" type="info" size="small" style="margin: 2px;">车牌故障</el-tag>
              <el-tag v-if="scope.row.isFootFailure === 1" type="info" size="small" style="margin: 2px;">支架故障</el-tag>
              <el-tag v-if="scope.row.isBicycleHeadFailure === 1" type="warning" size="small" style="margin: 2px;">车头故障</el-tag>
              <el-tag v-if="scope.row.isChainFailure === 1" type="warning" size="small" style="margin: 2px;">链条故障</el-tag>
              <el-tag v-if="scope.row.isWheelFailure === 1" type="warning" size="small" style="margin: 2px;">轮子故障</el-tag>
              <el-tag v-if="scope.row.isOtherFailure === 1" type="info" size="small" style="margin: 2px;">其他故障</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="feedback" label="反馈信息" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="distributorName" label="运营商" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="图片" width="80">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="showImages(scope.row.picUrl)" 
                v-if="scope.row.picUrl">查看</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="insertTime" label="报修时间" width="160"></el-table-column>
          <el-table-column prop="csRemark" label="客服备注" min-width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="180" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-view" @click="handleView(scope.row)">详情</el-button>
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)">处理</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="margin-top: 20px;"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog title="报修详情" :visible.sync="viewDialogVisible" width="600px" append-to-body>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="手机号">{{ viewForm.mobile }}</el-descriptions-item>
        <el-descriptions-item v-if="isAdmin" label="运营商">{{ viewForm.distributorName }}</el-descriptions-item>
        <el-descriptions-item label="报修时间" :span="2">{{ viewForm.insertTime }}</el-descriptions-item>
        <el-descriptions-item label="故障类型" :span="2">
          <el-tag v-if="viewForm.isLockFailure === 1" type="danger" size="small" style="margin-right: 5px;">车锁故障</el-tag>
          <el-tag v-if="viewForm.isBreakFailure === 1" type="warning" size="small" style="margin-right: 5px;">刹车故障</el-tag>
          <el-tag v-if="viewForm.isQrFailure === 1" type="info" size="small" style="margin-right: 5px;">车牌故障</el-tag>
          <el-tag v-if="viewForm.isFootFailure === 1" type="info" size="small" style="margin-right: 5px;">支架故障</el-tag>
          <el-tag v-if="viewForm.isBicycleHeadFailure === 1" type="warning" size="small" style="margin-right: 5px;">车头故障</el-tag>
          <el-tag v-if="viewForm.isChainFailure === 1" type="warning" size="small" style="margin-right: 5px;">链条故障</el-tag>
          <el-tag v-if="viewForm.isWheelFailure === 1" type="warning" size="small" style="margin-right: 5px;">轮子故障</el-tag>
          <el-tag v-if="viewForm.isOtherFailure === 1" type="info" size="small" style="margin-right: 5px;">其他故障</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="反馈信息" :span="2">{{ viewForm.feedback || '-' }}</el-descriptions-item>
        <el-descriptions-item label="报修图片" :span="2">
          <div v-if="viewForm.picUrl" class="image-list">
            <el-image 
              v-for="(url, index) in getPicUrls(viewForm.picUrl)" 
              :key="index"
              :src="url" 
              :preview-src-list="getPicUrls(viewForm.picUrl)"
              style="width: 80px; height: 80px; margin-right: 10px;"
              fit="cover"
            />
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="客服备注" :span="2">{{ viewForm.csRemark || '-' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <el-dialog title="处理报修" :visible.sync="handleDialogVisible" width="500px" append-to-body>
      <el-form ref="handleForm" :model="handleForm" :rules="handleRules" label-width="100px">
        <el-form-item label="用户信息:">
          <span>{{ handleForm.realName }} ({{ handleForm.mobile }})</span>
        </el-form-item>
        <el-form-item label="故障类型:">
          <span>
            <el-tag v-if="handleForm.isLockFailure === 1" type="danger" size="small" style="margin-right: 5px;">车锁故障</el-tag>
            <el-tag v-if="handleForm.isBreakFailure === 1" type="warning" size="small" style="margin-right: 5px;">刹车故障</el-tag>
            <el-tag v-if="handleForm.isQrFailure === 1" type="info" size="small" style="margin-right: 5px;">车牌故障</el-tag>
            <el-tag v-if="handleForm.isFootFailure === 1" type="info" size="small" style="margin-right: 5px;">支架故障</el-tag>
            <el-tag v-if="handleForm.isBicycleHeadFailure === 1" type="warning" size="small" style="margin-right: 5px;">车头故障</el-tag>
            <el-tag v-if="handleForm.isChainFailure === 1" type="warning" size="small" style="margin-right: 5px;">链条故障</el-tag>
            <el-tag v-if="handleForm.isWheelFailure === 1" type="warning" size="small" style="margin-right: 5px;">轮子故障</el-tag>
            <el-tag v-if="handleForm.isOtherFailure === 1" type="info" size="small" style="margin-right: 5px;">其他故障</el-tag>
          </span>
        </el-form-item>
        <el-form-item label="客服备注:" prop="csRemark">
          <el-input v-model="handleForm.csRemark" type="textarea" :rows="4" placeholder="请输入客服备注" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看图片" :visible.sync="imageDialogVisible" width="800px" append-to-body>
      <div class="image-preview-list">
        <el-image 
          v-for="(url, index) in previewImages" 
          :key="index"
          :src="url" 
          :preview-src-list="previewImages"
          style="width: 150px; height: 150px; margin: 10px;"
          fit="cover"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
  name: 'RepairManage',
  data() {
    return {
      loading: false,
      isAdmin: false,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        failureType: '',
        mobile: '',
        dateRange: [],
        queryDistributorId: ''
      },
      distributorOptions: [],
      repairList: [],
      viewDialogVisible: false,
      viewForm: {},
      handleDialogVisible: false,
      handleForm: {},
      handleRules: {
        csRemark: [{ required: true, message: '请输入客服备注', trigger: 'blur' }]
      },
      imageDialogVisible: false,
      previewImages: []
    }
  },
  created() {
    this.checkAdmin()
    this.getDistributorOptions()
    this.queryParams.queryDistributorId = getCurrentDistributorId()
    this.getList()
    // 监听运营商切换事件
    this.$root.$on('distributorChanged', this.handleDistributorChange)
  },
  beforeDestroy() {
    // 移除事件监听
    this.$root.$off('distributorChanged', this.handleDistributorChange)
  },
  methods: {
    handleDistributorChange(distributorId) {
      this.queryParams.queryDistributorId = distributorId || ''
      this.queryParams.pageNum = 1
      this.getList()
    },
    checkAdmin() {
      this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true'
    },
    getDistributorOptions() {
      this.$http.get('/distributor/manager/getAllDistributorInfo').then(res => {
        if (res.data.code === 200) {
          this.distributorOptions = res.data.data || []
        }
      })
    },
    getList() {
      this.loading = true
      const params = {
        page: this.queryParams.pageNum,
        limit: this.queryParams.pageSize,
        distributorId: this.queryParams.distributorId,
        failureType: this.queryParams.failureType,
        mobile: this.queryParams.mobile,
        status: 1,
        startDate: '',
        endDate: '',
        queryDistributorId: this.queryParams.queryDistributorId
      }
      if (this.queryParams.dateRange && this.queryParams.dateRange.length === 2) {
        params.startDate = this.queryParams.dateRange[0]
        params.endDate = this.queryParams.dateRange[1]
      }
      
      this.$http.post('/repair/manager/getRepairRecordPageInfo', params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.repairList = res.data.data.list || []
          this.total = res.data.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        distributorId: '',
        failureType: '',
        mobile: '',
        dateRange: [],
        queryDistributorId: getCurrentDistributorId()
      }
      this.getList()
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    getPicUrls(picUrl) {
      if (!picUrl) return []
      return picUrl.split(',').filter(url => url.trim())
    },
    showImages(picUrl) {
      this.previewImages = this.getPicUrls(picUrl)
      this.imageDialogVisible = true
    },
    handleView(row) {
      this.viewForm = { ...row }
      this.viewDialogVisible = true
    },
    handleUpdate(row) {
      this.handleForm = { ...row }
      this.handleDialogVisible = true
    },
    submitHandle() {
      this.$refs.handleForm.validate(valid => {
        if (valid) {
          this.$http.post('/repair/manager/handleRepair', {
            id: this.handleForm.id,
            csRemark: this.handleForm.csRemark
          }).then(res => {
            if (res.data.code === 200) {
              this.$message.success('处理成功')
              this.handleDialogVisible = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.repair-container {
}

.box-card {
  margin-top: 15px;
}

.search-area {
  margin-bottom: 15px;
}

.table-container {
  margin-top: 15px;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
